export default "__VITE_ASSET__3984aad0__"